import { autoinject } from 'aurelia-framework';
import * as moment from 'moment';

@autoinject
export class DateFormatValueConverter {
	toView(value: Date, format: string = undefined) {
		if (!format) format = "LL";
		return moment.utc(value).format(format);
	}
	fromView(value) {
		return value;
	}
}
